import { useLanguage } from "@/iti-core-react/hooks/useLanguage";
import("./FooterFinancing.scss");

export default function FooterFinancing() {
	const { t } = useLanguage();

	// GVA
	const imgSrcGVALogo = `${
		import.meta.env.VITE_PUBLIC_PATH
	}assets/financiaciones/gva-conselleria-de-innovacion-industria-comercio-y-turismo.png`;

	// S3
	const imgSrcS3Logo = `${
		import.meta.env.VITE_PUBLIC_PATH
	}assets/financiaciones/s3.png`;

	// IVACE
	const imgSrcIvaceLogo = `${
		import.meta.env.VITE_PUBLIC_PATH
	}assets/financiaciones/ivace-gva.png`;

	// CDTI
	const imgSrcCDTILogo = `${
		import.meta.env.VITE_PUBLIC_PATH
	}assets/financiaciones/cdti.svg`;

	// UE
	const imgSrcUELogo = `${
		import.meta.env.VITE_PUBLIC_PATH
	}assets/financiaciones/union-europea.svg`;

	// Plan Recuperacio, transformacio i resiliencia
	const imgSrcRTRLogo = `${
		import.meta.env.VITE_PUBLIC_PATH
	}assets/financiaciones/plan-recuperacion-transformacion-y-resilencia.svg`;

	return (
		<div>
			<div className="row">
				<div className="financing-by">{t("login.financed-by")}</div>
			</div>
			<div className="row align-items-center logos-container">
				<div className="col-gva">
					<img src={imgSrcGVALogo} alt="GVA" className="gva-image" />
				</div>
				<div className="col-s3">
					<img src={imgSrcS3Logo} alt="S3" className="s3-image" />
				</div>
				<div className="col-ivace">
					<img src={imgSrcIvaceLogo} alt="IVACE" className="ivace-image" />
				</div>
				<div className="col-cdti">
					<img src={imgSrcCDTILogo} alt="CDTI" className="cdti-image" />
				</div>
				<div className="col-ue">
					<img src={imgSrcUELogo} alt="UE" className="ue-image" />
				</div>
				<div className="col-rtr">
					<img src={imgSrcRTRLogo} alt="PRTR" className="rtr-image" />
				</div>
			</div>
		</div>
	);
}
